/** 菜单 key → 侧栏 SVG 图标名 */
const MENU_ICON_BY_KEY = {
  dashboard: 'dashboard',
  customer: 'customer',
  opportunity: 'target',
  quote: 'quote',
  contract: 'contract',
  agent: 'agent',
  'sales-target': 'flag',
  'sales-perf': 'trophy',
  material: 'box',
  inventory: 'warehouse',
  project: 'folder',
  shipment: 'truck',
  delivery: 'check',
  invoice: 'receipt',
  receivable: 'money-in',
  receipt: 'wallet',
  expense: 'expense',
  payable: 'payable',
  pnl: 'calculator',
  cashflow: 'droplet',
  'profit-project': 'trend-up',
  'profit-customer': 'trend-down',
  'profit-agent': 'agent-chart',
  'sales-item-analysis': 'report',
  'sales-region': 'map',
  efficiency: 'user',
  report: 'report',
  forecast: 'forecast',
  'service-ticket': 'rules',
  reminder: 'bell',
  rules: 'rules',
  user: 'user',
  role: 'role',
  'role-permission': 'key',
  permission: 'lock'
}

export function resolveMenuIconKey(key) {
  return MENU_ICON_BY_KEY[key] || 'doc'
}

/** 模块头图标（分组级） */
export const GROUP_ICON = {
  客户管理: 'customer',
  销售管理: 'target',
  物料库存: 'box',
  项目交付: 'folder',
  收款管理: 'money-in',
  成本付款: 'payable',
  经营分析: 'trend-up',
  运营协同: 'bell',
  系统设置: 'settings'
}

export const MODULE_ICON_BY_CODE = {
  'module:overview': 'dashboard',
  'module:customer-mgmt': 'customer',
  'module:sales-mgmt': 'target',
  'module:material-mgmt': 'box',
  'module:project-mgmt': 'folder',
  'module:receivable-mgmt': 'money-in',
  'module:cost-mgmt': 'payable',
  'module:analysis-mgmt': 'trend-up',
  'module:ops-mgmt': 'bell',
  'module:system-mgmt': 'settings'
}
